import React from 'react'
import Toast from './../../Toastr/Toast'
import translate from '../../../utilities/translate'
import translations from './translations'
import SecondaryButton from '../../../widgets/Button/SecondaryButton'

// trans :: String -> String -> String
const trans = translate(translations)

export default ({
  locale,
  email,
  success,
  error,
  isRequesting,
  requestResetPassword,
}) => <div className="request-reset-password">
  { error ? <Toast message={ trans(locale)('error') } level="error" /> : null }
  { success ? <Toast message={ trans(locale)('success') } level="success" /> : null }

  <SecondaryButton disabled={ isRequesting || null === email } onClick={ () => requestResetPassword(email) }>
    { trans(locale)('reset') }
  </SecondaryButton>
</div>
